(() => {
  'use strict';
  const priority = ['orso-product-camiseta-orso-club-team-padel-10', 'orso-product-camiseta-orso-club-team-padel-esquerda'];
  function prioritize(scope) {
    const roots = [...(scope.matches?.('[data-orso-consultation]') ? [scope] : []), ...scope.querySelectorAll('[data-orso-consultation]')];
    for (const root of roots) {
      const grid = root.querySelector('.orso-consultation__grid');
      if (!grid) continue;
      const cards = priority.map((id) => [...grid.children].find((card) => card.id === id)).filter(Boolean);
      if (cards.length) grid.prepend(...cards);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prioritize(document), { once: true });
  else prioritize(document);
  document.addEventListener('shopify:section:load', (event) => prioritize(event.target));
})();
